import React, { Component } from "react";
import { inject, observer } from "mobx-react";
import { Button, Glyphicon, Tooltip, OverlayTrigger } from "react-bootstrap";

class Edit extends Component {
	render() {
		const tooltip = <Tooltip id="edit-button-tooltip">Edit</Tooltip>;

		return (
			<OverlayTrigger placement="top" overlay={tooltip}>
				<Button bsStyle="primary" {...this.props}>
					<Glyphicon glyph="pencil" />
				</Button>
			</OverlayTrigger>
		);
	}
}

export default inject("stores")(observer(Edit));



// WEBPACK FOOTER //
// ./src/Core/Components/Buttons/Edit.js